// Single source of truth for API base URLs across the frontend.
// Imported by every RTK Query slice + the booking-location socket
// hook instead of reading `process.env` everywhere.
//
// Kept here (not in routes.js) to keep route paths and external
// service endpoints separate concerns.

// Our TrustLab backend (auth, cart, bookings, reports, queries,
// feedback, notifications, site content, support, etc).
// Hardcoded so no `.env.local` localhost override can leak into a
// production build — change this single line to point elsewhere.

//Run in Production
export const API_BASE_URL = 'https://mytrustlab.com/api';

// Run in local Backend
// export const API_BASE_URL = 'http://localhost:5000/api';


// External eDOS Laravel system — separate concern from our backend.
// Powers the public Tests / Packages catalogue pages and the lab-
// portal eDOS directory.
export const EDOS_API_BASE_URL = 'https://dos.mytrustlab.com/api';

// IT Dose LIMS — patient lab-report fetches go DIRECTLY from the
// browser to this base URL. We can't proxy through our backend
// because IT Dose's WAF fingerprints TLS handshakes and rejects
// non-browser clients (Chrome passes, Node doesn't). The .aspx
// endpoint already sends Access-Control-Allow-Origin: * so the
// browser fetch is uncontroversial.
//
// After each fetch the frontend pings POST /api/log-report-view on
// OUR backend with the visit_id / test_id so we keep an audit trail
// in `webhook_logs` despite skipping the proxy.
export const ITDOSE_BASE_URL = 'https://mytrustlab.in/Trustlab';

// Socket.IO origin for the live trustian-tracking stream. Strips a
// trailing `/api` (or `/api/`) so we connect to the bare host.
export const SOCKET_BASE_URL = API_BASE_URL.replace(/\/api\/?$/, '');
